import { setSettingsThunk } from '../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../store/store';
import MotionWrapper from '../../../containers/MotionWrapper';
import { selectUserId } from '../../../store/auth/selectors';
import RadioButton from '../../../components/RadioButton';
import Toggle from '../../../components/Toggle';
import Button from '../../../components/Button';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import {
    selectProfileData,
    selectUpdatingSettings,
} from '../../../store/workspace/selectors';

function Settings() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const profile = useSelector(selectProfileData);
    const [matchSkills, setMatchSkills] = useState(true);
    const isLoading = useSelector(selectUpdatingSettings);
    const [seekingNewJob, setSeekingNewJob] = useState(true);

    useEffect(() => {
        if (profile) {
            setMatchSkills(profile.setting.matching);
            setSeekingNewJob(profile.setting.seeking);
        }
    }, [profile]);

    const enableAll = () => {
        setSeekingNewJob(true);
        setMatchSkills(true);
    };

    const disableAll = () => {
        setSeekingNewJob(false);
        setMatchSkills(false);
    };

    const submitSettings = () => {
        dispatch(setSettingsThunk({
            userId,
            seeking: seekingNewJob,
            matching: matchSkills,
        }));
    };

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.setting}>
                <div className={styles.setting_text}>
                    <span>Career status</span>
                    <span>Choose your Job status</span>
                </div>
                <div className={styles.options}>
                    <div className={styles.option} onClick={enableAll}>
                        <span>I am looking for a new job</span>
                        <RadioButton text='' checked={seekingNewJob} setChecked={enableAll} />
                    </div>
                    <div className={styles.option} onClick={disableAll}>
                        <span>I am not looking for a new job</span>
                        <RadioButton text='' checked={!seekingNewJob} setChecked={disableAll} />
                    </div>
                </div>
            </div>
            <div className={styles.setting}>
                <div className={styles.setting_text}>
                    <span>Matching jobs</span>
                    <span>You can change the setting</span>
                </div>
                <div className={styles.options}>
                    <div className={styles.option}>
                        <span>Match my skills with market opportunities</span>
                        <Toggle toggled={matchSkills} setToggle={setMatchSkills} disabled={!seekingNewJob} />
                    </div>
                </div>
            </div>
            <div className={styles.action}>
                <Button
                    type='Primary'
                    text='Save changes'
                    loading={isLoading}
                    onClick={submitSettings}
                />
            </div>
        </MotionWrapper>
    );
};

export default Settings;
